import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "NI_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#NI_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "NI_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#NI_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0zM0 16v8h32v-8H0z",
      fill: "#0080EC"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 8c.188 0 .374.013.555.038l-.198 1.276a2.732 2.732 0 00-.871.026l-.093-1.294c.198-.03.4-.046.607-.046zm1.152.168l-.348 1.244a2.71 2.71 0 011.904 2.677l1.287.11a4.002 4.002 0 00-2.843-4.03zm2.361 5.746a4 4 0 01-3.216 2.075v-1.296c.74-.08 1.391-.46 1.83-1.014l1.386.235zm-6.937.156a3.999 3.999 0 003.195 1.924V14.7a2.706 2.706 0 01-1.935-1.07l-1.26.44zm-.572-1.899a4.001 4.001 0 012.549-3.901l.333 1.26a2.71 2.71 0 00-1.595 2.45l-1.287.191z",
      fill: "#D0AB00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.975 8.95l-2.737 4.731h5.517l-2.78-4.73z",
      fill: "#7CDFFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "NI_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 13,
      y: 8,
      width: 6,
      height: 6
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.975 8.95l-2.737 4.731h5.517l-2.78-4.73z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#NI_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16 15.119a2.39 2.39 0 100-4.782 2.39 2.39 0 000 4.782z",
      stroke: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16 15.119a2.39 2.39 0 100-4.782 2.39 2.39 0 000 4.782z",
      stroke: "#FFD018"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16 15.119a2.39 2.39 0 100-4.782 2.39 2.39 0 000 4.782z",
      stroke: "#4EDD00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16 15.119a2.39 2.39 0 100-4.782 2.39 2.39 0 000 4.782z",
      stroke: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement("path", { fill: "#3D58DB", d: "M13.018 12.219h6.255v1.818h-6.255z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.438 12.99l1.246-1.239.383.62.267-.756.297.567.312-.43.403.43.37-.567.316.567.363-.43.847.9.153.339-4.957.251v-.251z",
      fill: "#97C923"
    }
  ))))
), a = t;
export {
  a as default
};
